import { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';

import { useMenu } from 'features/menu';
import MenuUser from 'features/menuUser';

import { getContrast } from 'app/utils';
import { ButtonIcon, Flex, Logo } from 'components';
import { useResources } from 'features/resources';
import { useSchool } from 'features/school';
import { SearchBar, SearchButton } from 'features/search';
import { SurveysList } from 'features/surveys';

const LogoWrapper = styled(Flex)`
  ${(props: any) => {
    if (props['data-schoolalias'] !== 'b3') {
      return `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `;
    }
  }}
`;

// const CustomLink = styled(Link)`
//   display: flex;
//   align-items: center;
//   padding: 0 20px;
//   position: relative;

//   &::before {
//     content: '';
//     display: block;
//     width: 1px;
//     height: 80%;
//     background: ${({ theme }) => theme.colors.dark_150};
//     position: absolute;
//     left: 0;
//   }
// `;

const Separator = styled.div`
  width: 1px;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: ${({ theme }) => theme.colors.dark_150};
`;

interface MainNavbarProps {
  withoutSearchButton?: boolean;
}

const MainNavbar = ({ withoutSearchButton }: MainNavbarProps): ReactElement => {
  const {
    colors: { navbarBg },
  } = useTheme();

  const { setMenuOpened } = useMenu();
  const { usingSearch, usingSurvey } = useResources();

  const { schoolAlias } = useSchool();

  const logoColor = getContrast(navbarBg, true, false);

  const { pathname } = useLocation();

  return (
    <>
      <Flex position="relative" zIndex={1010} bg="navbarBg" alignItems="center" flexWrap="nowrap" justifyContent="space-between" as="header">
        <Flex flexGrow={0}>
          <ButtonIcon
            width={{ m: 60, d: 80 }}
            height={{ m: 60, d: 80 }}
            justifyContent="center"
            icon="menu"
            onClick={() => setMenuOpened(true)}
            size="large"
            bg="transparent"
            color="white"
            colorHover="primary_400"
            colorClick="primary_200"
            aria-label="Abrir menu"
          />

          {pathname !== '/' && Boolean(window.history.length) && (
            <ButtonIcon
              icon="chevronLeft"
              width={{ m: 60, d: 80 }}
              height={{ m: 60, d: 80 }}
              iconWidth={30}
              bg="transparent"
              color="white"
              colorHover="primary_400"
              aria-label="Voltar"
              onClick={() => window.history.back()}
            />
          )}
        </Flex>

        <LogoWrapper data-schoolalias={schoolAlias}>
          <Link to="/">
            <Logo dark={logoColor === 'dark'} />
          </Link>
        </LogoWrapper>

        <Flex flexGrow={0} alignItems="stretch">
          {usingSearch && !withoutSearchButton && (
            <>
              <SearchButton />
              <Separator />
            </>
          )}

          {usingSurvey && (
            <>
              <SurveysList />
              <Separator />
            </>
          )}

          <Flex px={4}>
            <MenuUser />
          </Flex>
        </Flex>
      </Flex>

      <SearchBar />
    </>
  );
};
export default MainNavbar;
